'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

const CouponCard = require('./coupon-card');

function Popularcoupons({ coupons, routes }) {
  return h('.coupons-grid', [
    h('.coupons-grid-inner', [
      h(
        Translate,
        { tag: 'h2', attrs: { class: 'secondary-title' } },
        '.TopOffersHeadingFormat'
      ),
      h(
        '.coupons-grid-content',
        {
          'data-bhw': 'TopCoupons',
        },
        coupons.map(coupon =>
          h('.coupons-grid-column', CouponCard({ coupon, routes }))
        )
      ),
    ]),
  ]);
}

module.exports = Popularcoupons;
